export const mapToSelect = (value, label) => ({ label, value });

/**
 * Retorna un objeto { label: label, value: value } si la variable {data} es diferente de null,
 * de lo contrario, retorna un string vacío
 * @param {object} data objeto del cuál se extraerán las propiedades {label} y {value}
 * @param {string} value string que identifica la propiedad que será pasada como valor del select
 * @param {string} label string que identifica la propiedad que será pasada como label del select
 */
export const defaultValueSelect = (data, label, value) => {
    return data != null ? {...data, label: data[label], value: data[value]} : '';
};

export const defaultValueInput = (data, defaultValue = '') => {
    return data ?? defaultValue;
};